import * as Yup from "yup";

export const pickupValidationSchema = Yup.object({
  addressId: Yup.number().required("Please select an address").required(),
  alternateMobile: Yup.string()
    .nullable()
    .matches(/^[0-9]{10}$/, "Enter valid 10-digit mobile number")
    .transform((value) => (value === "" ? null : value)),

  isExpress: Yup.boolean(),

  opd: Yup.string().when("isExpress", {
    is: false,
    then: (schema) => schema.required("Select pickup date"),
    otherwise: (schema) => schema.nullable(),
  }),

  slot: Yup.string().when("isExpress", {
    is: false,
    then: (schema) => schema.required("Select time slot"),
    otherwise: (schema) => schema.nullable(),
  }),

  agreed: Yup.boolean()
    .oneOf([true], "You must agree to the terms")
    .required("You must agree to the terms"),
});
